import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import { useNotificationStore } from '../../stores/notificationStore';
import { useProfileStore } from '../../stores/profileStore';
import { AdminDesktopNavigation } from './AdminDesktopNavigation';

export const NOTIFICATION_REFRESH_INTERVAL = 1 * 60 * 1000;

export const AdminNavigation: React.FC = () => {
  const { signOut } = useAuth();
  const { profile } = useProfileStore();
  const navigate = useNavigate();
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const { unreadCount, fetchUnreadCount } = useNotificationStore();

  useEffect(() => {
    if (profile) {
      fetchUnreadCount();
      const interval = setInterval(() => {
        fetchUnreadCount();
      }, NOTIFICATION_REFRESH_INTERVAL);
      return () => clearInterval(interval);
    }
  }, [profile, fetchUnreadCount]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsAccountMenuOpen(false);
      }
    }
    if (isAccountMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isAccountMenuOpen]);

  const handleSignOut = () => {
    signOut();
    setIsAccountMenuOpen(false);
    navigate('/');
  };

  return (
    <nav className="px-4 pt-6 md:pt-2 md:px-4 relative hidden lg:block" ref={menuRef}>
      <AdminDesktopNavigation
        isAccountMenuOpen={isAccountMenuOpen}
        onSignOut={handleSignOut}
        onAccountMenuToggle={(forceClose = false) =>
          setIsAccountMenuOpen(forceClose ? false : !isAccountMenuOpen)
        }
        onCloseMenu={() => setIsAccountMenuOpen(false)}
        notifications={unreadCount}
      />
    </nav>
  );
};
